goog.provide('el8.ptdata.model.consents');

goog.require('el8.model.base');


el8.ptdata.model.consents = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.addStringProperty('application', true);
    _class.addBoolean('consented', true);
    _class.addBoolean('isActive', true);
    _class.addDateTime('lastUpdated', true);

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        saveFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('consents', [el8Globals.PATIENT_ID, item.getId()]),
                data: JSON.stringify(item.asMap()),
                success: function(data) {
                    item.populate(data);
                    successCb(data);
                }
            });
        },

    });

    return that;
})();
